<template>
  <div class="audi-progress">
    <div
      v-for="(step, sIndex) in progressLength"
      :key="step"
      class="audi-progress__group"
    >
      <button
        :class="[
          'audi-progress__btn',
          (step === currentStep + 1 || step < currentStep + 1) && 'audi-progress__btn--filled'
        ]"
        @click="handler(sIndex)"
      />
      <div class="audi-progress__popover-container">
        Étape {{ step }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudiProgress',
  props: {
    progressLength: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    }
  },
  methods: {
    handler(step) {
      if (step === this.currentStep || step < this.currentStep) {
        this.$emit('go-to', step)
      }
    }
  }
}
</script>

<style lang="scss">
.audi-progress {
  $self: &;

  position: absolute;
  display: flex;
  inset: 0;
  padding: 0;
  gap: .3rem;
  height: 14px;
  top: 4px;

  &__group {
    flex: 1;
  }

  &__popover-container {
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s cubic-bezier(0.75, 0.02, 0.5, 1);

    position: relative;
    background-color: white;
    color: black;
    font-size: 1.4rem;
    padding: 10px 0;
    text-align: center;
    width: 80%;
    margin: 8px auto 0 auto;

    &::after {
      content: "";
      position: absolute;
      top: -17px;
      left: 50%;
      transform: translateX(-50%);
      border-width: 10px;
      border-style: solid;
      border-color: transparent transparent white transparent;
    }
  }

  &__btn {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.30);
    height: 100%;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;

    &--filled {
      background-color: white;

      &:hover + #{ $self }__popover-container {
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
</style>